<template>
  <LayoutModalComponent parentRoute="news">
    <PagesNewsSlugComponent
      :pageData="data"
    />
  </LayoutModalComponent>
</template>

<script setup>
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryNewsEntryBySlug(baseStrapiGetSlugQueryObjectFromRoute()) } }
  )
})

if (!data?.value?.data?.length || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)
</script>
